<template>
  <div class="spl-login">
    <div class="top-container">
      <div class="left-top"></div>
      <div class="right-top"></div>
    </div>
    <div class="bottom-container">
      <div class="left-bottom"></div>
      <div class="right-bottom"></div>
    </div>
    <div class="container">
      <div class="logo-account">
        <img class="logo" :src="logo" alt />
      </div>
      <p class="sub-title">欢迎登录亿店宝供应商端</p>
      <div class="title">登录</div>
      <div class="form-container">
        <div class="form">
          <p class="error-message">{{errorMessage}}</p>
          <el-input
            class="input m20"
            v-model="username"
            @keyup.enter.native="supplierLogin"
            placeholder="账号"
          >
            <img slot="prefix" class="small-icon" src="../../../assets/supplier/user.png" />
          </el-input>
          <el-input
            class="input"
            v-model="password"
            @keyup.enter.native="supplierLogin"
            placeholder="密码"
            type="password"
          >
            <img slot="prefix" class="psd" src="../../../assets/supplier/psd.png" />
          </el-input>
          <el-button class="login" @click="supplierLogin">登录</el-button>
          <p class="save-password">
            <!-- <el-checkbox v-model="savePassword">记住密码</el-checkbox> -->
            <span class="register" @click="toPage('/supplier/spl-user/spl-register')">立即注册</span>
            <span class="password" @click="toPage('/supplier/spl-user/spl-password')">忘记密码?</span>
          </p>
        </div>
      </div>
    </div>
    <div class="user-login-footer">
      <div class="footer-bottom">
        <p class="code">
          <a href="https://beian.miit.gov.cn" target="_blank">{{ code }}</a>
        </p>
        <p class="ydb">由亿店宝提供技术支持</p>
      </div>
    </div>
  </div>
</template>

<script>
import {
  saveSupplierUser,
  getSupplierUser,
  removeSupplierUser,
  saveToken,
  saveGetModify,
  saveStorageModify,
  saveStorageIn,
  saveSupplierName,
  saveGoodsDel,
  saveSupplierStatus,
  saveSupplierBasicInformation,
  getSupplierTitleInfo,
} from "common/js/storage";
import Supplier from "models/spl/supplier.js";
const supplier = new Supplier();
export default {
  data() {
    return {
      logo: "",
      username: "",
      password: "",
      savePassword: false,
      errorMessage: "",
      code: ''
    };
  },
  created() {
    let data = getSupplierUser();
    this.username = data.username;
    this.password = data.password;
    if (this.username) {
      this.savePassword = true;
    }
  },
  mounted() {
    this.basicInformation();
  },
  methods: {
    toPage(url) {
      this.$router.push(url);
    },
    supplierLogin() {
      this.errorMessage = "";
      if (this.username === "" || this.password === "") {
        this.errorMessage = "请输入账号或者密码";
        return false;
      }
      let data = {};
      data.username = this.username;
      data.password = this.password;
      supplier.postSupplierLogin(data).then((res) => {
        if (res.success) {
          saveGetModify(res.result.goodsModify)
          saveStorageIn(res.result.storageIn)
          saveStorageModify(res.result.storageModify)
          saveToken(res.result.token);
          saveSupplierStatus(res.result.status);
          saveSupplierName(res.result.username);
          saveGoodsDel(res.result.goodsDel);
          this.getSupplierBasicInformation()
          if (this.savePassword) {
            saveSupplierUser(data);
          } else {
            removeSupplierUser();
          }
          this.$router.push({
            path: "/supplier",
          });
        } else {
          this.errorMessage = res.message;
        }
      });
    },
    // 获取基础信息
    basicInformation() {
      if (getSupplierTitleInfo() === "") {
        setTimeout(() => {
          let res = getSupplierTitleInfo();
          this.logo = res.logo;
          this.code = res.companyNumber;
        }, 600);
      } else {
        let res = getSupplierTitleInfo();
        this.logo = res.logo;
        this.code = res.companyNumber;
      }
    },
    getSupplierBasicInformation() {
      supplier.getSupplierBasicInformation().then(res => {
        if (res.success) {
          saveSupplierBasicInformation(res.result)
        } else {
          this.errorMessage = res.message;
        }
      })
    }
  },
};
</script>
<style lang='scss' scoped>
.spl-login {
  width: 100vw;
  height: 100vh;
  background: #fff;
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
  .top-container {
    .left-top {
      position: absolute;
      left: 101px;
      top: 105px;
      width: 211px;
      height: 145px;
      background: url(../../../assets/supplier/bg-left-top.png) no-repeat;
    }
    .right-top {
      position: absolute;
      right: 235px;
      top: 167px;
      width: 88px;
      height: 98px;
      background: url(../../../assets/supplier/bg-right-top.png) no-repeat;
    }
  }
  .bottom-container {
    .left-bottom {
      position: absolute;
      left: 120px;
      bottom: 96px;
      width: 30px;
      height: 15px;
      background: url(../../../assets/supplier/bg-left-bottom.png) no-repeat;
    }
    .right-bottom {
      position: absolute;
      right: 0px;
      bottom: 53px;
      width: 236px;
      height: 205px;
      background: url(../../../assets/supplier/bg-right-bottom.png) no-repeat;
    }
  }
  .container {
    height: 500px;
    .logo-account {
      display: flex;
      justify-content: center;
      align-items: center;
      height: 48px;
      margin-bottom: 12px;
      font-size: 16px;
      color: #666666;
      .logo {
        width: 146px;
      }
    }
    .sub-title {
      font-size: 16px;
      font-weight: 400;
      color: #999999;
      line-height: 24px;
      text-align: center;
      margin-bottom: 40px;
    }
    .title {
      font-size: 20px;
      font-weight: bold;
      color: #333333;
      line-height: 24px;
    }
    .form-container {
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      margin-top: 19px;
      .form {
        width: 320px;
        position: relative;
        .error-message {
          position: absolute;
          font-size: 12px;
          top: -20px;
          color: rgba(195, 13, 35, 1);
        }
        .small-icon {
          width: 19px;
          height: 20px;
        }
        .psd {
          width: 17px;
          height: 20px;
        }
        .m20 {
          margin-bottom: 20px;
        }
        .login {
          margin-top: 20px;
        }
        .save-password {
          margin-top: 10px;
          margin-bottom: 20px;
          font-size: 14px;
          display: flex;
          justify-content: space-between;
          color: rgba(195, 13, 35, 1);
          .password {
            cursor: pointer;
          }
        }
        .el-button {
          width: 320px;
          height: 42px;
          background: rgba(195, 13, 35, 1);
          border-radius: 4px;
          font-size: 16px;
          color: rgba(247, 247, 247, 1);
        }
      }
    }
  }
  .user-login-footer {
    position: absolute;
    bottom: 29px;
    background: #fff;
    display: flex;
    flex-direction: column;
    align-items: center;
    .footer-bottom {
      box-sizing: border-box;
      display: flex;
      align-items: center;
      justify-content: center;
      p {
        font-size: 14px;
        color: #a4a4a4;
        line-height: 14px;
        padding: 0 10px;
      }
      .ydb {
        border-left: 1px solid #a4a4a4;
      }
      .code {
        cursor: pointer;
        a {
          color: #a4a4a4;
          outline: none;
        }
      }
    }
  }
}
</style>
<style lang="scss">
.spl-login {
  .el-input {
    .el-input__inner:focus {
      border-color: rgba(195, 13, 35, 1);
    }
    .el-input__prefix {
      left: 11px;
    }
    .el-input__prefix, .el-input__suffix {
      top: 10px;
      height: 20px;
    }
    .el-input__inner {
      padding-left: 40px;
    }
  }
}
</style>